import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { State } from "../../State";
import { Direction } from "../constants";
import GestureHandler from "./GestureHandler";
var DEFAULT_MAX_DURATION_MS = 800;
var DEFAULT_MIN_ACCEPTABLE_DELTA = 160;
var DEFAULT_DIRECTION = Direction.RIGHT;
var DEFAULT_NUMBER_OF_TOUCHES_REQUIRED = 1;
var FlingGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(FlingGestureHandler, GestureHandler);
    var _super = _create_super(FlingGestureHandler);
    function FlingGestureHandler() {
        _class_call_check(this, FlingGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "numberOfPointersRequired", DEFAULT_NUMBER_OF_TOUCHES_REQUIRED);
        _define_property(_assert_this_initialized(_this), "direction", DEFAULT_DIRECTION);
        _define_property(_assert_this_initialized(_this), "maxDurationMs", DEFAULT_MAX_DURATION_MS);
        _define_property(_assert_this_initialized(_this), "minAcceptableDelta", DEFAULT_MIN_ACCEPTABLE_DELTA);
        _define_property(_assert_this_initialized(_this), "delayTimeout", void 0);
        _define_property(_assert_this_initialized(_this), "startX", 0);
        _define_property(_assert_this_initialized(_this), "startY", 0);
        _define_property(_assert_this_initialized(_this), "maxNumberOfPointersSimultaneously", 0);
        _define_property(_assert_this_initialized(_this), "keyPointer", NaN);
        return _this;
    }
    _create_class(FlingGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(FlingGestureHandler.prototype), "init", this).call(this, ref, propsRef);
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(FlingGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
                if (this.config.direction) {
                    this.direction = this.config.direction;
                }
                if (this.config.numberOfPointers) {
                    this.numberOfPointersRequired = this.config.numberOfPointers;
                }
            }
        },
        {
            key: "startFling",
            value: function startFling() {
                var _this = this;
                this.startX = this.tracker.getLastX(this.keyPointer);
                this.startY = this.tracker.getLastY(this.keyPointer);
                this.begin();
                this.maxNumberOfPointersSimultaneously = 1;
                this.delayTimeout = setTimeout(function() {
                    return _this.fail();
                }, this.maxDurationMs);
            }
        },
        {
            key: "tryEndFling",
            value: function tryEndFling() {
                if (this.maxNumberOfPointersSimultaneously === this.numberOfPointersRequired && (this.direction & Direction.RIGHT && this.tracker.getLastX(this.keyPointer) - this.startX > this.minAcceptableDelta || this.direction & Direction.LEFT && this.startX - this.tracker.getLastX(this.keyPointer) > this.minAcceptableDelta || this.direction & Direction.UP && this.startY - this.tracker.getLastY(this.keyPointer) > this.minAcceptableDelta || this.direction & Direction.DOWN && this.tracker.getLastY(this.keyPointer) - this.startY > this.minAcceptableDelta)) {
                    clearTimeout(this.delayTimeout);
                    this.activate();
                    return true;
                }
                return false;
            }
        },
        {
            key: "endFling",
            value: function endFling() {
                if (!this.tryEndFling()) {
                    this.fail();
                }
            }
        },
        {
            key: "onPointerDown",
            value: function onPointerDown(event) {
                this.tracker.addToTracker(event);
                this.keyPointer = event.pointerId;
                _get(_get_prototype_of(FlingGestureHandler.prototype), "onPointerDown", this).call(this, event);
                this.newPointerAction();
            }
        },
        {
            key: "onPointerAdd",
            value: function onPointerAdd(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(FlingGestureHandler.prototype), "onPointerAdd", this).call(this, event);
                this.newPointerAction();
            }
        },
        {
            key: "newPointerAction",
            value: function newPointerAction() {
                if (this.currentState === State.UNDETERMINED) {
                    this.startFling();
                }
                if (this.currentState !== State.BEGAN) {
                    return;
                }
                this.tryEndFling();
                if (this.tracker.getTrackedPointersCount() > this.maxNumberOfPointersSimultaneously) {
                    this.maxNumberOfPointersSimultaneously = this.tracker.getTrackedPointersCount();
                }
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                this.tracker.track(event);
                if (this.currentState !== State.BEGAN) {
                    return;
                }
                this.tryEndFling();
                _get(_get_prototype_of(FlingGestureHandler.prototype), "onPointerMove", this).call(this, event);
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(FlingGestureHandler.prototype), "onPointerUp", this).call(this, event);
                this.onUp(event);
                this.keyPointer = NaN;
            }
        },
        {
            key: "onPointerRemove",
            value: function onPointerRemove(event) {
                _get(_get_prototype_of(FlingGestureHandler.prototype), "onPointerRemove", this).call(this, event);
                this.onUp(event);
            }
        },
        {
            key: "onUp",
            value: function onUp(event) {
                this.tracker.removeFromTracker(event.pointerId);
                if (this.currentState !== State.BEGAN) {
                    return;
                }
                this.endFling();
            }
        },
        {
            key: "activate",
            value: function activate(force) {
                _get(_get_prototype_of(FlingGestureHandler.prototype), "activate", this).call(this, force);
                this.end();
            }
        },
        {
            key: "resetConfig",
            value: function resetConfig() {
                _get(_get_prototype_of(FlingGestureHandler.prototype), "resetConfig", this).call(this);
                this.numberOfPointersRequired = DEFAULT_NUMBER_OF_TOUCHES_REQUIRED;
                this.direction = DEFAULT_DIRECTION;
            }
        }
    ]);
    return FlingGestureHandler;
}(GestureHandler);
export { FlingGestureHandler as default };
